import { SessionStorageService } from '@/js/session-storage'
import axios from 'axios'

class TokenIconDeliver {
  constructor (url) {
    this.url = url
    this.storage = new SessionStorageService('tokenIconManifest')
  }

  async loadManifest () {
    let manifest = this.storage.get()
    if (!manifest) {
      const url = `${this.url}/manifest.json`
      const { data } = await axios.get(url)
      this.storage.set(data)
    }
  }

  getIconUrl (symbol) {
    let manifest = this.storage.get()
    const found = manifest.find(row => row.symbol === symbol)
    if (!found) {
      return `${this.url}/svg/color/generic.svg`
    }
    return `${this.url}/svg/color/${symbol.toLowerCase()}.svg`
  }
}

export const tokenIconDeliver = new TokenIconDeliver(
  'https://cdn.jsdelivr.net/gh/atomiclabs/cryptocurrency-icons'
)
